// import React, { useState } from 'react';
// import { Box, Button, Typography, Paper, TextField, IconButton, InputAdornment, Link as MuiLink,Snackbar, Alert } from '@mui/material';
// import { Link, useNavigate } from 'react-router-dom';
// import { ArrowForward, ArrowBack } from '@mui/icons-material';
// import { consultLogin, providerLogin } from "../services/authService";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { validatePin } from '../services/customerSessionDetails';

// function ConsultLoginPage() {
//   const navigate = useNavigate();
//   const [showPatientLogin, setShowPatientLogin] = useState(false);
//   const [showProviderLogin, setShowProviderLogin] = useState(true);
//   const [pin, setPin] = useState('');
//   const [email, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [loginError, setLoginError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
// const [snackbarMessage, setSnackbarMessage] = useState("");
// const [snackbarSeverity, setSnackbarSeverity] = useState("error"); // success | error | warning | info
  

//   const handleClickShowPassword = () => setShowPassword((prev) => !prev);

//   const handleProviderLogin = async (e) => {
//   e.preventDefault();
//   setLoginError("");

//   try {
//     const data = await consultLogin({ email, password });

//     console.log("LOGIN RESPONSE:", data); // debug

//     // ✅ Check login success
//     if (!data?.auth || !data?.user) {
//   setSnackbarMessage("Invalid login response");
//   setSnackbarSeverity("error");
//   setOpenSnackbar(true);
//   return;
// }

//     const user = data.user;

//     // ✅ Package check
//     const allowedPackages = ["premium", "premium+"];

//    if (!allowedPackages.includes(user.cust_type?.toLowerCase())) {
//   setSnackbarMessage(
//     "Portal access is available only for Premium and Premium+ customers"
//   );
//   setSnackbarSeverity("error");
//   setOpenSnackbar(true);
//   return;
// }

//     // ✅ Save message
//     if (data.message) {
//       localStorage.setItem("loginMessage", data.message);
//     }

//     // ✅ Save user data
//     localStorage.setItem("user", JSON.stringify(user));
//     localStorage.setItem("name", user.name);
//     localStorage.setItem("pid", user.pid);
//     localStorage.setItem("relation", user.relation);
//     localStorage.setItem("role", "customer");

//     const appAccounts = {
//   echobuddy: 1,
//   echomindnest: 0,
//   musicccare: 0,
// };

    
//     localStorage.setItem("appData", JSON.stringify({
//       app_name: "musicccare",
//       account_id: appAccounts["musicccare"],
//     }));

//     // ✅ Navigate
//     navigate("/appointment/booking");

//   } catch (error) {
//   console.log("FULL ERROR:", error);
//   console.log("ERROR RESPONSE:", error.response);
//   console.log("ERROR DATA:", error.response?.data);

//   const message =
//     error?.response?.data?.error || error.message || "Login failed";

//   setSnackbarMessage(message);
//   setSnackbarSeverity("error");
//   setOpenSnackbar(true);
// }

// };

//   // const handleBackToPortalSelection = () => {
//   //   setShowPatientLogin(false);
//   //   setShowProviderLogin(false);
//   //   setPin('');
//   //   setUsername('');
//   //   setPassword('');
//   //   setLoginError('');
//   // };

//   return (
//     <Box sx={{
//       minHeight: '100vh',
//       minWidth: '100vw',
//       width: '100vw',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
//       p: 2,
//       position: 'relative',
//       overflow: 'hidden'
//     }}>
//       {/* Background animated circles */}
//       <Box
//         sx={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           pointerEvents: 'none',
//           zIndex: 0,
//         }}
//       >
//         <Box
//           sx={{
//             position: 'absolute',
//             width: 400,
//             height: 400,
//             borderRadius: '50%',
//             top: -100,
//             right: -100,
//             background: 'linear-gradient(135deg, #2ECC71, #1ABC9C)',
//             opacity: 0.1,
//             animation: 'float 20s infinite ease-in-out',
//             animationDelay: '0s',
//           }}
//         />
//         <Box
//           sx={{
//             position: 'absolute',
//             width: 300,
//             height: 300,
//             borderRadius: '50%',
//             bottom: -50,
//             left: -50,
//             background: 'linear-gradient(135deg, #1ABC9C, #9B59B6)',
//             opacity: 0.1,
//             animation: 'float 20s infinite ease-in-out',
//             animationDelay: '-5s',
//           }}
//         />
//         <Box
//           sx={{
//             position: 'absolute',
//             width: 200,
//             height: 200,
//             borderRadius: '50%',
//             top: '50%',
//             left: '10%',
//             background: 'linear-gradient(135deg, #9B59B6, #A855F7)',
//             opacity: 0.1,
//             animation: 'float 20s infinite ease-in-out',
//             animationDelay: '-10s',
//           }}
//         />
//       </Box>

//       {/* Float keyframes */}
//       <Box
//         component="style"
//         children={`
//           @keyframes float {
//             0%,100% { transform: translate(0,0) scale(1); }
//             25% { transform: translate(20px,-20px) scale(1.05); }
//             50% { transform: translate(-10px,20px) scale(0.95); }
//             75% { transform: translate(-20px,-10px) scale(1.02); }
//           }
//         `}
//       />
//       {/* Logo */}
//       <Box
//         sx={{
//           position: 'absolute',
//           top: { xs: 18, sm: 18, md: 24 },
//           left: 24,
//           zIndex: 1000,
//           animation: 'slideDown 1.3s ease-out forwards',
//           '@keyframes slideDown': {
//             '0%': { transform: 'translateY(-50px)', opacity: 0 },
//             '100%': { transform: 'translateY(0)', opacity: 1 },
//           },
//         }}
//       >
//         <Box sx={{
//           display: 'inline-flex',
//           alignItems: 'center',
//           gap: 2,
//           backdropFilter: 'blur(10px)',
//           borderRadius: '16px',
//         }}>
//           <img
//             src="/echobuddy-logo.png"
//             alt="echoCare Logo"
//             style={{
//               height: '44px',
//               width: 'auto',
//               marginTop: "4px"
//             }}
//           />
//           <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//             <Typography
//               sx={{
//                 fontSize: '1.4rem',
//                 fontWeight: 700,
//                 letterSpacing: 0.8,
//                 background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//                 backgroundClip: 'text',
//               }}
//             >
//               MUSICC Care
//             </Typography>

//             <Typography
//               sx={{
//                 fontSize: '0.65rem',
//                 fontWeight: 500,
//                 letterSpacing: 0.6,
//                 background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//                 backgroundClip: 'text',
//               }}
//             >
//               Heal. Hope. Harmony.
//             </Typography>
//           </Box>
//         </Box>
//       </Box>

//       {/* Left Side Content */}
//       <Box sx={{
//         display: { xs: 'none', md: 'flex' },
//         flexDirection: 'column',
//         color: 'white',
//         maxWidth: '50%',
//         p: 4,
//         zIndex: 1
//       }}>
//         <Typography variant="caption"
//           sx={{
//             fontSize: '1.5rem',
//             fontWeight: 500,
//             letterSpacing: '0.3px',
//             background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//             WebkitBackgroundClip: 'text',
//             WebkitTextFillColor: 'transparent',
//             backgroundClip: 'text',
//             display: 'inline-block',
//             lineHeight: 1.4,
//             mb: 1
//           }}>
//           Heal. Hope. Harmony.
//         </Typography>
//         <Typography variant="caption"
//           sx={{
//             fontSize: '0.9rem',
//             fontWeight: 500,
//             letterSpacing: '0.3px',
//             background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//             WebkitBackgroundClip: 'text',
//             WebkitTextFillColor: 'transparent',
//             backgroundClip: 'text',
//             display: 'inline-block',
//             lineHeight: 1.4,
//           }}>
//           Comprehensive patient management platform with AI-powered mental wellness support and personalized music therapy.
//         </Typography>

//         <Box sx={{ mt: 4 }}>
//           <Typography sx={{ mb: 1 }}>
//             🏥 <span style={{
//               fontSize: 14,
//               fontWeight: 500,
//               opacity: 0.8,
//               background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent',
//               backgroundClip: 'text',
//               display: 'inline-block'
//             }}>Healthcare Provider Solutions</span>
//           </Typography>

//           <Typography sx={{ mb: 1 }}>
//             🎵 <span style={{
//               fontSize: 14,
//               fontWeight: 500,
//               opacity: 0.8,
//               background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent',
//               backgroundClip: 'text',
//               display: 'inline-block'
//             }}>Personalized Music Therapy</span>
//           </Typography>

//           <Typography sx={{ mb: 3 }}>
//             📊 <span style={{
//               fontSize: 14,
//               fontWeight: 500,
//               opacity: 0.8,
//               background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent',
//               backgroundClip: 'text',
//               display: 'inline-block'
//             }}>Clinical Assessment Tools</span>
//           </Typography>

//           {/* Certification Badges - Below Clinical Assessment Tools */}
//           <Box sx={{
//             display: 'flex',
//             justifyContent: 'flex-start',
//             alignItems: 'center',
//             gap: 2,
//             flexWrap: 'wrap'
//           }}>

//             <Box sx={{ textAlign: 'center', mr: 3 }}>
//               <img
//                 src="/iso.svg"
//                 alt="ISO Certified"
//                 style={{ height: 60, width: 70, filter: 'hue-rotate(90deg) saturate(1.2) brightness(1.1)' }}
//               />
//               <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
//                 ISO 27001<br />Certified
//               </Typography>
//             </Box>
//             <Box sx={{ textAlign: 'center', mr: 1 }}>
//               <img
//                 src="/wfmh.svg"
//                 alt="WFMH Member" style={{ height: 50 }} />
//               <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
//                 WFMH<br />Member
//               </Typography>
//             </Box>
//             <Box sx={{ textAlign: 'center' }}>
//               <img
//                 src="/hipa.svg"
//                 alt="HIPAA Compliant"
//                 style={{ height: 50, filter: 'hue-rotate(90deg) saturate(1.2) brightness(1.1)' }}
//               />
//               <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
//                 HIPAA<br />Compliant
//               </Typography>
//             </Box>
//           </Box>
//         </Box>
//       </Box>

//       {/* Portal Selection */}
//       <Paper
//         elevation={24}
//         sx={{
//           width: '100%',
//           maxWidth: 520,
//           borderRadius: 4,
//           px: { xs: 3, md: 4 },
//           py: { xs: 4, md: 5 },
//           bgcolor: 'rgba(255, 255, 255, 0.95)',
//           backdropFilter: 'blur(20px)',
//           border: '1px solid rgba(0,0,0,0.05)',
//           boxShadow: '0 24px 40px rgba(0, 0, 0, 0.12)',
//           zIndex: 1,
//           margin: { xs: '0 16px', md: '0 32px' }
//         }}
//       >

//         {showProviderLogin ? (
//           // Provider Login View
//           <>
//             <Box sx={{ textAlign: 'center', mb: { xs: 2, sm: 2, md: 4 } }}>
//               <Typography
//                 sx={{
//                   color: '#1F2937',
//                   fontSize: { xs: 22, md: 32 },
//                   fontWeight: 800,
//                   mb: 1,
//                   background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                   WebkitBackgroundClip: 'text',
//                   WebkitTextFillColor: 'transparent',
//                   backgroundClip: 'text',
//                 }}
//               >
//                 Care Appointment Login
//               </Typography>
//               <Typography sx={{
//                 color: '#64748B',
//                 fontSize: 16,
//                 lineHeight: 1.6,
//                 fontSize: { xs: 13, sm: 15, md: 16 }
//               }}>
//                 Enter your credentials to access the provider dashboard
//               </Typography>
//             </Box>

//             <form onSubmit={handleProviderLogin}>
//               <TextField
//                 fullWidth
//                 label="Email"
//                 value={email}
//                 onChange={(e) => setUsername(e.target.value)}
//                 placeholder="Enter Email"
//                 variant="outlined"
//                 sx={{ mb: 2 }}
//                 required
//               />

//               <TextField
//                 fullWidth
//                 label="Password"
//                 type={showPassword ? "text" : "password"}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="Enter password"
//                 variant="outlined"
//                 sx={{
//                   mb: { xs: 1.5, sm: 2, md: 3 },
//                   backgroundColor: "#e0f7ff", // your sky blue background
//                   "& .MuiOutlinedInput-root": {
//                     backgroundColor: "#e0f7ff",
//                   },
//                 }}
//                 error={!!loginError}
//                 helperText={loginError}
//                 required
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end" sx={{ backgroundColor: "#e0f7ff", borderRadius: "4px" }}>
//                       <IconButton
//                         onClick={handleClickShowPassword}
//                         edge="end"
//                         disableRipple
//                         disableFocusRipple
//                         sx={{
//                           outline: "none",
//                           "&:focus": {
//                             outline: "none",
//                             boxShadow: "none",
//                           },
//                           backgroundColor: "#e0f7ff",
//                         }}
//                       >
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />

//               <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
//                 <MuiLink
//                   component={Link}
//                   to="/consult/forgotpassword"
//                   sx={{ color: '#6B7280', fontSize: 13, textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, mb: { xs: 1.5, sm: 2, md: 3 }, }}
//                 >
//                   Forgot Password?
//                 </MuiLink>
//               </Box>

//               <Button
//                 type="submit"
//                 variant="contained"
//                 fullWidth
//                 sx={{
//                   borderRadius: 2,
//                   height: 48,
//                   background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                   color: '#ffffff',
//                   fontSize: { xs: 14, sm: 16, md: 16 },
//                   fontWeight: 700,
//                   textTransform: 'none',
//                   boxShadow: '0 8px 20px rgba(34, 197, 94, 0.35)',
//                   mb: 2,
//                   '&:hover': {
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 12px 30px rgba(34, 197, 94, 0.5)',
//                   }
//                 }}
//               >
//                 Login to Provider Portal
//                 <ArrowForward sx={{ ml: 1, fontSize: 18 }} />
//               </Button>
//             </form>


//           </>
//         ) : null}
//       </Paper>
//       <Snackbar
//   open={openSnackbar}
//   autoHideDuration={3000}
//   onClose={() => setOpenSnackbar(false)}
//   anchorOrigin={{ vertical: "top", horizontal: "right" }} // ✅ TOP RIGHT
// >
//   <Alert
//     onClose={() => setOpenSnackbar(false)}
//     severity={snackbarSeverity}
//     variant="filled"
//     sx={{ width: "100%" }}
//   >
//     {snackbarMessage}
//   </Alert>
// </Snackbar>
//     </Box >
//   );
// }

// export default ConsultLoginPage;


import React, { useState } from 'react';
import { Box, Button, Typography, Paper, TextField, IconButton, InputAdornment, Link as MuiLink,Snackbar, Alert } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowForward, ArrowBack } from '@mui/icons-material';
import { consultLogin, providerLogin } from "../services/authService";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { validatePin } from '../services/customerSessionDetails';

function ConsultLoginPage() {
  const navigate = useNavigate();
  const [showPatientLogin, setShowPatientLogin] = useState(false);
  const [showProviderLogin, setShowProviderLogin] = useState(true);
  const [pin, setPin] = useState('');
  const [email, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState("");
const [snackbarSeverity, setSnackbarSeverity] = useState("error"); // success | error | warning | info
  

  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  const handleProviderLogin = async (e) => {
  e.preventDefault();
  setLoginError("");

  try {
    const data = await consultLogin({ email, password });

    console.log("LOGIN RESPONSE:", data); // debug

    // ✅ Check login success
    if (!data?.auth || !data?.user) {
  setSnackbarMessage("Invalid login response");
  setSnackbarSeverity("error");
  setOpenSnackbar(true);
  return;
}

    const user = data.user;

    // ✅ Package check
    const allowedPackages = ["premium", "premium+"];

   if (!allowedPackages.includes(user.cust_type?.toLowerCase())) {
  setSnackbarMessage(
    "Portal access is available only for Premium and Premium+ customers"
  );
  setSnackbarSeverity("error");
  setOpenSnackbar(true);
  return;
}

    // ✅ Save message
    if (data.message) {
      localStorage.setItem("loginMessage", data.message);
    }

    // ✅ Save user data
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("name", user.name);
    localStorage.setItem("pid", user.pid);
    localStorage.setItem("relation", user.relation);
    localStorage.setItem("role", "customer");

       const appAccounts = {
  echobuddy: 1,
  echomindnest: 0,
  musicccare: 0,
};

    
    localStorage.setItem("appData", JSON.stringify({
      app_name: "musicccare",
      account_id: appAccounts["musicccare"],
    }));

    // ✅ Navigate
    navigate("/appointment/booking");

  } catch (error) {
  console.log("FULL ERROR:", error);
  console.log("ERROR RESPONSE:", error.response);
  console.log("ERROR DATA:", error.response?.data);

  const message =
    error?.response?.data?.error || error.message || "Login failed";

  setSnackbarMessage(message);
  setSnackbarSeverity("error");
  setOpenSnackbar(true);
}

};

  // const handleBackToPortalSelection = () => {
  //   setShowPatientLogin(false);
  //   setShowProviderLogin(false);
  //   setPin('');
  //   setUsername('');
  //   setPassword('');
  //   setLoginError('');
  // };

  return (
    <Box sx={{
      minHeight: '100vh',
      minWidth: '100vw',
      width: '100vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
      p: 2,
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background animated circles */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            width: 400,
            height: 400,
            borderRadius: '50%',
            top: -100,
            right: -100,
            background: 'linear-gradient(135deg, #2ECC71, #1ABC9C)',
            opacity: 0.1,
            animation: 'float 20s infinite ease-in-out',
            animationDelay: '0s',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: 300,
            height: 300,
            borderRadius: '50%',
            bottom: -50,
            left: -50,
            background: 'linear-gradient(135deg, #1ABC9C, #9B59B6)',
            opacity: 0.1,
            animation: 'float 20s infinite ease-in-out',
            animationDelay: '-5s',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: 200,
            height: 200,
            borderRadius: '50%',
            top: '50%',
            left: '10%',
            background: 'linear-gradient(135deg, #9B59B6, #A855F7)',
            opacity: 0.1,
            animation: 'float 20s infinite ease-in-out',
            animationDelay: '-10s',
          }}
        />
      </Box>

      {/* Float keyframes */}
      <Box
        component="style"
        children={`
          @keyframes float {
            0%,100% { transform: translate(0,0) scale(1); }
            25% { transform: translate(20px,-20px) scale(1.05); }
            50% { transform: translate(-10px,20px) scale(0.95); }
            75% { transform: translate(-20px,-10px) scale(1.02); }
          }
        `}
      />
      {/* Logo */}
      <Box
        sx={{
          position: 'absolute',
          top: { xs: 18, sm: 18, md: 24 },
          left: 24,
          zIndex: 1000,
          animation: 'slideDown 1.3s ease-out forwards',
          '@keyframes slideDown': {
            '0%': { transform: 'translateY(-50px)', opacity: 0 },
            '100%': { transform: 'translateY(0)', opacity: 1 },
          },
        }}
      >
        <Box sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 2,
          backdropFilter: 'blur(10px)',
          borderRadius: '16px',
        }}>
          <img
            src="/echobuddy-logo.png"
            alt="echoCare Logo"
            style={{
              height: '44px',
              width: 'auto',
              marginTop: "4px"
            }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              sx={{
                fontSize: '1.4rem',
                fontWeight: 700,
                letterSpacing: 0.8,
                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              MUSICC Care
            </Typography>

            <Typography
              sx={{
                fontSize: '0.65rem',
                fontWeight: 500,
                letterSpacing: 0.6,
                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              Heal. Hope. Harmony.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Left Side Content */}
      <Box sx={{
        display: { xs: 'none', md: 'flex' },
        flexDirection: 'column',
        color: 'white',
        maxWidth: '50%',
        p: 4,
        zIndex: 1
      }}>
        <Typography variant="caption"
          sx={{
            fontSize: '1.5rem',
            fontWeight: 500,
            letterSpacing: '0.3px',
            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            display: 'inline-block',
            lineHeight: 1.4,
            mb: 1
          }}>
          Heal. Hope. Harmony.
        </Typography>
        <Typography variant="caption"
          sx={{
            fontSize: '0.9rem',
            fontWeight: 500,
            letterSpacing: '0.3px',
            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            display: 'inline-block',
            lineHeight: 1.4,
          }}>
          Comprehensive patient management platform with AI-powered mental wellness support and personalized music therapy.
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography sx={{ mb: 1 }}>
            🏥 <span style={{
              fontSize: 14,
              fontWeight: 500,
              opacity: 0.8,
              background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              display: 'inline-block'
            }}>Healthcare Provider Solutions</span>
          </Typography>

          <Typography sx={{ mb: 1 }}>
            🎵 <span style={{
              fontSize: 14,
              fontWeight: 500,
              opacity: 0.8,
              background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              display: 'inline-block'
            }}>Personalized Music Therapy</span>
          </Typography>

          <Typography sx={{ mb: 3 }}>
            📊 <span style={{
              fontSize: 14,
              fontWeight: 500,
              opacity: 0.8,
              background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              display: 'inline-block'
            }}>Clinical Assessment Tools</span>
          </Typography>

          {/* Certification Badges - Below Clinical Assessment Tools */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap'
          }}>

            <Box sx={{ textAlign: 'center', mr: 3 }}>
              <img
                src="/iso.svg"
                alt="ISO Certified"
                style={{ height: 60, width: 70, filter: 'hue-rotate(90deg) saturate(1.2) brightness(1.1)' }}
              />
              <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
                ISO 27001<br />Certified
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'center', mr: 1 }}>
              <img
                src="/wfmh.svg"
                alt="WFMH Member" style={{ height: 50 }} />
              <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
                WFMH<br />Member
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <img
                src="/hipa.svg"
                alt="HIPAA Compliant"
                style={{ height: 50, filter: 'hue-rotate(90deg) saturate(1.2) brightness(1.1)' }}
              />
              <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
                HIPAA<br />Compliant
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Portal Selection */}
      <Paper
        elevation={24}
        sx={{
          width: '100%',
          maxWidth: 520,
          borderRadius: 4,
          px: { xs: 3, md: 4 },
          py: { xs: 4, md: 5 },
          bgcolor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(0,0,0,0.05)',
          boxShadow: '0 24px 40px rgba(0, 0, 0, 0.12)',
          zIndex: 1,
          margin: { xs: '0 16px', md: '0 32px' }
        }}
      >

        {showProviderLogin ? (
          // Provider Login View
          <>
            <Box sx={{ textAlign: 'center', mb: { xs: 2, sm: 2, md: 4 } }}>
              <Typography
                sx={{
                  color: '#1F2937',
                  fontSize: { xs: 22, md: 32 },
                  fontWeight: 800,
                  mb: 1,
                  background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                Care Appointment Login
              </Typography>
              <Typography sx={{
                color: '#64748B',
                fontSize: 16,
                lineHeight: 1.6,
                fontSize: { xs: 13, sm: 15, md: 16 }
              }}>
                Enter your credentials to access the provider dashboard
              </Typography>
            </Box>

            <form onSubmit={handleProviderLogin}>
              <TextField
                fullWidth
                label="Email"
                value={email}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter Email"
                variant="outlined"
                sx={{ mb: 2 }}
                required
              />

              <TextField
                fullWidth
                label="Password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                variant="outlined"
                sx={{
                  mb: { xs: 1.5, sm: 2, md: 3 },
                  backgroundColor: "#e0f7ff", // your sky blue background
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#e0f7ff",
                  },
                }}
                error={!!loginError}
                helperText={loginError}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ backgroundColor: "#e0f7ff", borderRadius: "4px" }}>
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        disableRipple
                        disableFocusRipple
                        sx={{
                          outline: "none",
                          "&:focus": {
                            outline: "none",
                            boxShadow: "none",
                          },
                          backgroundColor: "#e0f7ff",
                        }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                <MuiLink
                  component={Link}
                  to="/consult/forgotpassword"
                  sx={{ color: '#6B7280', fontSize: 13, textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, mb: { xs: 1.5, sm: 2, md: 3 }, }}
                >
                  Forgot Password?
                </MuiLink>
              </Box>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  borderRadius: 2,
                  height: 48,
                  background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                  color: '#ffffff',
                  fontSize: { xs: 14, sm: 16, md: 16 },
                  fontWeight: 700,
                  textTransform: 'none',
                  boxShadow: '0 8px 20px rgba(34, 197, 94, 0.35)',
                  mb: 2,
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 30px rgba(34, 197, 94, 0.5)',
                  }
                }}
              >
                Login to Provider Portal
                <ArrowForward sx={{ ml: 1, fontSize: 18 }} />
              </Button>
            </form>


          </>
        ) : null}
      </Paper>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={3000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: "top", horizontal: "right" }} // ✅ TOP RIGHT
>
  <Alert
    onClose={() => setOpenSnackbar(false)}
    severity={snackbarSeverity}
    variant="filled"
    sx={{ width: "100%" }}
  >
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Box >
  );
}

export default ConsultLoginPage;


